import { useMemo, useRef } from 'react';
import { addHours, format } from 'date-fns';

import { selectors } from 'selectors/selectors';
import { useSelector } from 'react-redux';

const formatDates = (dates) => {
  const startDateYear = format(addHours(new Date(dates.startDate), 8), 'yyyy');
  const startDateMonth = format(addHours(new Date(dates.startDate), 8), 'MMMM');
  return `${startDateMonth} ${startDateYear}`;
};

export const useReportingGraphDateSelectionFriendly = () => {
  const renderRef = useRef(false);
  const state = useSelector(selectors.boundFormStateById('crmReportsScreen'));
  const dates = state.dates;
  const triggerFetch = state.fetch;

  useMemo(() => {
    if (dates) {
      renderRef.current = formatDates(dates);
    }
  }, []);

  const formatDateForView = useMemo(() => {
    if (!dates) {
      return null;
    }

    if (triggerFetch) {
      renderRef.current = formatDates(dates);
      return formatDates(dates);
    } else {
      return renderRef.current;
    }
  }, [dates, triggerFetch]);

  return formatDateForView;
};
